<template>
  <div>
    <div>
      <span>客户接待>护士</span>
      <el-divider></el-divider>
    </div>
    <div class="layout-page-box">
      <el-form :inline="true" label-width="80px" label-position="right" class="search-form">
        <el-form-item label="患者">
          <el-input v-model="filters.positionCode" clearable></el-input>
        </el-form-item>
        <el-form-item label="客户类型">
          <el-select v-model="filters.client" placeholder="请选择项目类型" style="width:90%">
            <el-option v-for="item in clientType" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="filters.createBy" clearable></el-input>
        </el-form-item>
        <el-form-item label="前台">
          <el-input v-model="filters.createBy" clearable></el-input>
        </el-form-item>
        <el-form-item label="客服">
          <el-input v-model="filters.createBy" clearable></el-input>
        </el-form-item>
        <el-form-item label="护士">
          <el-input v-model="filters.positionName" clearable></el-input>
        </el-form-item>
        <el-form-item label="技师">
          <el-input v-model="filters.createBy" clearable></el-input>
        </el-form-item>
        <el-form-item label="添加时间">
          <el-date-picker v-model="filters.startTime" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-input placeholder="请输入关键字" v-model="filters.keyword">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="query(1)">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="danger" @click="del">删除</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" @click="refresh">手动刷新</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 主体内容 -->
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="待接待(25)" name="0"></el-tab-pane>
      <el-tab-pane label="待治疗(25)" name="1"></el-tab-pane>
    </el-tabs>

    <nurseChild></nurseChild>
  </div>
</template>

<script>
import nurseChild from './nurseChild.vue'
export default {
  components: {
    nurseChild
  },
  data() {
    return {
      clientType: [{
        value: 0,
        label: '全部'
      }, {
        value: 1,
        label: '患者'
      }, {
        value: 2,
        label: '陪同'
      },],
      filters: {},
      activeName: '0'
    }
  },
  methods: {
    // tab切换事件
    handleClick(tab, event) {
      console.log(tab, event);
    },
    del() {

    },
    refresh() {

    },
  }
}
</script>

<style scoped>
</style>